
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';

interface LocationHeroProps {
  title: string;
  description: string;
  image?: string;
}

const LocationHero = ({ title, description, image }: LocationHeroProps) => {
  return (
    <section className="relative bg-gradient-to-r from-piano-black to-gray-900 text-white py-16 lg:py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="max-w-xl animate-fade-in">
            <h1 className="text-4xl md:text-5xl font-serif font-bold leading-tight mb-6">
              {title}
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              {description}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-piano-gold hover:bg-piano-gold/90 text-white">
                <Link to="/kontakt">Book Gratis Prøvetime</Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="bg-white border-white text-piano-black hover:bg-white/90">
                <Link to="/undervisning">Se Undervisningstilbud</Link>
              </Button>
            </div>
          </div>
          {image && (
            <div className="relative hidden lg:block">
              <div className="w-full h-96 rounded-lg shadow-2xl overflow-hidden">
                <img 
                  src={image} 
                  alt={title} 
                  className="w-full h-full object-cover"
                  width="600"
                  height="400"
                  loading="eager"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default LocationHero;
